export default () => {
    const extensions = map => ({
        forceRerenderChildren(node) {
            node.change('children')

            for (const n of map.children(node)) {
                n.change('data')
                n.change('parent')
            }
        },
    })

    return {extensions}
}
